// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Isle of Man */
const IM = /^(?:76245[06]\d{4}|7(?:4576|[59]24\d|624[0-4689])\d{5})$/;

export default IM;
